import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useNavigationContext } from './use-navigation-context';

/**
 * Settings-specific navigation context hook
 * Automatically tracks user's previous context when navigating to settings
 * Supports both tenant and organization-operator views
 */
export function useSettingsNavigation() {
  const { pathname } = useLocation();
  const { saveContext } = useNavigationContext({
    contextType: 'settings',
    ttl: 24 * 60 * 60 * 1000, // 24 hours
  });

  // Auto-save context when NOT in settings
  useEffect(() => {
    if (pathname.startsWith('/settings') || pathname === '/') return;

    let context: Parameters<typeof saveContext>[0];

    if (pathname.startsWith('/tenant')) {
      context = {
        previousUrl: '/tenant',
        previousLabel: 'Organization Group Dashboard',
        metadata: {
          view: 'tenant',
        },
      };
    } else if (pathname.startsWith('/org/')) {
      const slugMatch = pathname.match(/^\/org\/([^\/]+)/);
      const slug = slugMatch?.[1];

      context = {
        previousUrl: `/org/${slug}`,
        previousLabel: 'Organization Dashboard', // Could fetch actual name from API
        metadata: {
          view: 'organization',
          slug,
        },
      };
    } else {
      context = {
        previousUrl: '/',
        previousLabel: 'Home',
        metadata: {
          view: 'unknown',
        },
      };
    }

    saveContext(context);
  }, [pathname, saveContext]);
}
